// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"732":"54eefde6","977":"abc85231"}[chunkId] + ".chunk.js";
};